import React from 'react';
import { Filter as FilterAdmin, TextInput, SelectInput } from 'react-admin';

import { PeriodoInput, PrecoInput } from '../../Components/InputsReactAdmin';
import { rotuloStatusDevolucaoNfce } from '../../utils';
import {
  STATUS_EMISSAO_NFCE_PENDENTE,
  STATUS_EMISSAO_NFCE_AUTORIZADA,
  STATUS_EMISSAO_NFCE_AUTORIZADA_SEM_XML,
  STATUS_EMISSAO_NFCE_CANCELADA,
  STATUS_EMISSAO_NFCE_CONTINGENCIA,
  STATUS_EMISSAO_NFCE_CONTINGENCIA_ENVIADA,
  STATUS_EMISSAO_NFCE_DENEGADA,
  STATUS_EMISSAO_NFCE_INDEFINIDA,
  STATUS_EMISSAO_NFCE_PROCESSANDO,
  STATUS_EMISSAO_NFCE_REJEITADA,
  STATUS_EMISSAO_NFCE_REJEITADA_DEFINITIVO,
  STATUS_EMISSAO_NFCE_DESCONHECIDO,
  STATUS_EMISSAO_NFCE_REJEITADA_REPROCESSAMENTO,
  STATUS_DEVOLUCAO_NFCE_PENDENTE,
  STATUS_DEVOLUCAO_NFCE_PROCESSANDO,
  STATUS_DEVOLUCAO_NFCE_AUTORIZADA,
  STATUS_DEVOLUCAO_NFCE_REJEITADA,
  STATUS_DEVOLUCAO_NFCE_INDEFINIDA,
  STATUS_DEVOLUCAO_NFCE_FALHA_DEFINITIVA,
} from '../../utils/constants';

const choices = [
  { id: STATUS_EMISSAO_NFCE_PENDENTE, name: 'Pendente' },
  { id: STATUS_EMISSAO_NFCE_PROCESSANDO, name: 'Processando' },
  { id: STATUS_EMISSAO_NFCE_AUTORIZADA, name: 'Autorizada' },
  { id: STATUS_EMISSAO_NFCE_AUTORIZADA_SEM_XML, name: 'Autorizada sem XML' },
  { id: STATUS_EMISSAO_NFCE_CONTINGENCIA, name: 'Contingência' },
  {
    id: STATUS_EMISSAO_NFCE_CONTINGENCIA_ENVIADA,
    name: 'Contingência enviada',
  },
  { id: STATUS_EMISSAO_NFCE_CANCELADA, name: 'Cancelada' },
  { id: STATUS_EMISSAO_NFCE_DENEGADA, name: 'Denegada' },
  { id: STATUS_EMISSAO_NFCE_REJEITADA, name: 'Rejeitada' },
  { id: STATUS_EMISSAO_NFCE_INDEFINIDA, name: 'Indefinida' },
  {
    id: STATUS_EMISSAO_NFCE_REJEITADA_DEFINITIVO,
    name: 'Rejeitada Definitivo',
  },
  {
    id: STATUS_EMISSAO_NFCE_DESCONHECIDO,
    name: 'Desconhecido',
  },
  {
    id: STATUS_EMISSAO_NFCE_REJEITADA_REPROCESSAMENTO,
    name: 'Rejeitada Reprocessamento',
  },
];

const choicesDevolucao = [
  STATUS_DEVOLUCAO_NFCE_PENDENTE,
  STATUS_DEVOLUCAO_NFCE_PROCESSANDO,
  STATUS_DEVOLUCAO_NFCE_AUTORIZADA,
  STATUS_DEVOLUCAO_NFCE_REJEITADA,
  STATUS_DEVOLUCAO_NFCE_INDEFINIDA,
  STATUS_DEVOLUCAO_NFCE_FALHA_DEFINITIVA,
].map((id) => ({ id, name: rotuloStatusDevolucaoNfce(id) }));

const Filter = (props) => (
  <FilterAdmin {...props}>
    <SelectInput
      source="status_emissao_nfce"
      choices={choices}
      label="Status da Emissão"
      allowEmpty={false}
    />
    <PeriodoInput
      source="periodo"
      label="Peŕiodo"
      defaultValue={{
        start: new Date(),
        end: new Date(),
      }}
    />
    <SelectInput
      source="status_devolucao_nfce"
      choices={choicesDevolucao}
      label="Status da Conversão"
      allowEmpty
    />
    <TextInput source="numero" label="Número da venda" />
    <TextInput source="erro_sefaz" label="Erro" />
    <PrecoInput
      source="valor"
      label="Valor da venda"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorDinheiro"
      label="Valor Parcela Dinheiro"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorPix"
      label="Valor Parcela Pix"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorDebito"
      label="Valor Parcela Débito"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorVonchuer"
      label="Valor Parcela Voucher"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorDescontoDevolucao"
      label="Valor Parcela Devolução"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorCredito"
      label="Valor Parcela Crédito"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorBoleto"
      label="Valor Parcela Boleto"
      fixedDecimalScale={false}
    />
  </FilterAdmin>
);

export default Filter;
